















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import DetailPlayer from "./detail_player.vue";

@Component({
  components: {
    DetailPlayer
  }
})
export default class extends Mixins(MyList) {
  @Prop() userId!: number;

  @Prop() type!: string;
}
